import { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import Loading from '../components/Loading';
// protected routes

// pages
import NotFound from '../pages/Page404';

import BaseLayout from '../layouts/BaseLayout';

import productsRoutes from '../productsController/routes';

// import ProtectedRoutes from './ProtectedRoutes';
import ProtectedKeycloakRoutes from './ProtectedKeycloakRoutes';
import { RetomarDestino } from './destinoAposLogin';

import {
  loginRoutes,
  adminRoutes,
  anywhereRoutes,
  anywhereAdminRoutes,
  licenciamentoRoutes,
  licenciamentoEntradaRoute,
} from './defaultRoutes';

// ----------------------------------------------------------------------

const Home = lazy(() => import('../pages/Dashboard/Dashboard'));
const Alerts = lazy(() => import('../pages/Alerts'));

const baseProductUrl = '/products';

export default function Router() {
  const { initialized, keycloak } = useKeycloak();

  const roles = keycloak?.tokenParsed?.resource_access?.['dashboard-back']?.roles || [];
  let anywhereEntryPath = '/dashboard';
  if (roles.includes('Anywhere')) anywhereEntryPath = '/anywhere/terminais';
  else if (roles.includes('Anywhere_Admin')) anywhereEntryPath = '/anywhere/admin/clientes';

  return (
    <>
      <Loading loading={!initialized} height={'100vh'} />
      <RetomarDestino />
      <Routes>
        {loginRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={route.component} />
        ))}
        {/* <Route element={<ProtectedRoutes />}> */}
        <Route element={<ProtectedKeycloakRoutes />}>
          <Route path="/">
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route path="*" element={<Navigate to="/404" />} />
            <Route path="/404" element={<NotFound />} />
          </Route>

          <Route
            path="/dashboard"
            element={
              <Suspense fallback={<BaseLayout loading />}>
                <Home />
              </Suspense>
            }
          />
          <Route
            path="/alerts"
            element={
              <Suspense fallback={<BaseLayout loading />}>
                <Alerts />
              </Suspense>
            }
          />
          {adminRoutes.map((route) => (
            <Route key={route.path} path={route.path} element={route.component} />
          ))}
          <Route
            path="/anywhere"
            element={<Navigate to={anywhereEntryPath} replace />}
          />
          {anywhereRoutes.map((route) => {
            const hasRequiredRole = !route.requiredRole || roles.includes(route.requiredRole);

            return (
              <Route
                key={route.path}
                path={route.path}
                element={hasRequiredRole ? route.component : <Navigate to="/dashboard" replace />}
              />
            );
          })}
          {anywhereAdminRoutes.map((route) => {
            const hasRequiredRole = !route.requiredRole || roles.includes(route.requiredRole);

            return (
              <Route
                key={route.path}
                path={route.path}
                element={hasRequiredRole ? route.component : <Navigate to="/dashboard" replace />}
              />
            );
          })}
          <Route path={licenciamentoEntradaRoute.path} element={licenciamentoEntradaRoute.component} />
          {licenciamentoRoutes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={roles.includes(route.requiredRole) ? route.component : <Navigate to="/dashboard" replace />}
            />
          ))}
          {productsRoutes.map((route) => {
            const hasRequiredRole = !route.requiredRole || roles.includes(route.requiredRole);

            return (
              <Route
                key={route.path}
                path={`${baseProductUrl + route.path}`}
                element={hasRequiredRole ? <route.component /> : <Navigate to="/dashboard" replace />}
              />
            );
          })}
        </Route>
        <Route path="*" element={<Navigate to="/404" replace />} />
        <Route path="/404" element={<NotFound />} />
      </Routes>
    </>
  );
}
